module.exports = __webpack_public_path__ + "static/media/YM89_2.b1249aa9.jpg";